import { motion } from "framer-motion";
import { fileUrl } from "@/lib/api";

export default function Hero({ siteInfo }) {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-32 pb-20 sm:pt-40 sm:pb-32 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-end">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-7"
        >
          <p className="text-xs sm:text-sm uppercase tracking-[0.25em] text-sage font-bold mb-8" data-testid="hero-overline">
            Meisterbetrieb · seit {new Date().getFullYear() - (siteInfo?.years_experience || 25)}
          </p>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl tracking-tight leading-[1.02] text-stone-900 mb-8" data-testid="hero-headline">
            Farbe, die <em className="text-clay not-italic">bleibt</em>.<br />
            Handwerk, das <span className="italic">spricht</span>.
          </h1>
          <p className="max-w-xl text-lg text-stone-600 leading-relaxed mb-10" data-testid="hero-subhead">
            {siteInfo?.tagline}. Vom feinen Innenanstrich bis zur kompletten Fassadensanierung –
            wir gestalten Räume mit Charakter.
          </p>
          <div className="flex flex-wrap items-center gap-4">
            <a
              href="#contact"
              data-testid="hero-cta-primary"
              className="px-7 py-3.5 bg-stone-900 text-sand-100 hover:bg-clay transition-colors duration-300 rounded-sm"
            >
              Kostenloses Angebot
            </a>
            <a
              href="#vorher-nachher"
              data-testid="hero-cta-secondary"
              className="px-7 py-3.5 border border-stone-900 text-stone-900 hover:bg-stone-900 hover:text-sand-100 transition-colors duration-300 rounded-sm"
            >
              Unsere Arbeit ansehen
            </a>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 1.05 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-5 relative"
        >
          <div className="relative aspect-[4/5] overflow-hidden rounded-sm">
            <img
              src={siteInfo?.hero_image_path ? fileUrl(siteInfo.hero_image_path) : "https://images.pexels.com/photos/1669754/pexels-photo-1669754.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=720"}
              alt="Hand rollt frische Farbe"
              className="w-full h-full object-cover"
              data-testid="hero-image-main"
            />
          </div>
          <div className="absolute -bottom-6 -left-6 sm:-left-12 hidden sm:block">
            <div className="bg-sand-100 border border-sand-300 px-6 py-5 rounded-sm" data-testid="hero-badge">
              <p className="font-display text-4xl text-clay leading-none">{siteInfo?.projects_completed || 480}+</p>
              <p className="text-xs uppercase tracking-[0.2em] text-stone-600 mt-2">Projekte realisiert</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
